import { Box, Modal, ModalOverlay, ModalContent, ModalBody, useColorMode } from '@chakra-ui/react';

import { BasicInfoSection, CardsGridSection, DescriptionSection, ImageSection } from './index';
import { Button } from '../../ui';
import { useCalendarSettings, useModal } from '../../../lib';
import { useCallback } from 'react';

export const EventDetailModal: React.FunctionComponent = () => {
	const { isOpen, closeModal, content } = useModal();
	const { colorMode } = useColorMode();
	const { settings } = useCalendarSettings();

	const event = content?.event;

	const handleRegisterEvent = useCallback(() => {
		if (event && event.url) {
			window.open(event.url, '_blank');
		}
	}, [event]);

	if (!content || !settings?.formats) {
		return <></>;
	}

	const { isSameDayEvent } = content;
	const { timeLabel, locationLabel, eventDetailLabel, showMoreLabel, registerEventButtonLabel } = settings;
	const { dateFormat, monthFormat, timeFormat } = settings.formats;
	const { eventModalBackgroundColor } = settings.styles[colorMode];
	return (
		<Modal isOpen={isOpen} size='3xl' onClose={closeModal} scrollBehavior='inside'>
			<ModalOverlay />
			<ModalContent minW={{ md: '850px' }} bg='none'>
				<ModalBody p={0} bg={eventModalBackgroundColor} borderRadius='xl'>
					<Box tabIndex={0} />
					<BasicInfoSection
						event={event}
						isSameDayEvent={isSameDayEvent}
						monthFormat={monthFormat}
						timeFormat={timeFormat}
					/>
					{event.image && <ImageSection url={event.image} />}
					<CardsGridSection
						event={event}
						isSameDayEvent={isSameDayEvent}
						dateFormat={dateFormat}
						timeFormat={timeFormat}
						timeLabel={timeLabel}
						locationLabel={locationLabel}
					/>
					{event?.description && (
						<DescriptionSection
							description={event.description}
							eventDetailLabel={eventDetailLabel}
							showMoreLabel={showMoreLabel}
						/>
					)}
					<Box p={2} w='full'>
						<Button
							p='20px'
							color='white'
							backgroundColor='#5193DC'
							size='lg'
							borderRadius='sm'
							w='full'
							onClick={handleRegisterEvent}
						>
							{registerEventButtonLabel}
						</Button>
					</Box>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};
